import { yupResolver } from "@hookform/resolvers/yup"
import { LoadingButton } from "@mui/lab"
import { Box, Grid } from "@mui/material"
import { useEffect, useState } from "react"
import { FieldValues, useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { CustomScorecardSettings } from "../../Component/Api/CustomScorecardSettings/CustomScorecardSettings"
import { ConfirmationDialog } from "../../Component/Common/Components/ConfirmationDialog"
import AppTextInput from "../../Component/Common/Components/FormValidationInputs/AppTextInput"
import { MDTypography } from "../../Component/Common/Components/MDTypography"
import { CustomScorecard } from "../../Component/Model/Dto/Scorecard/CustomScorecard"
import { SettingType } from "../../Component/Model/Enum/BEE123Enums"
import { CustomFieldNameValidationScheme } from "./CustomFieldNameValidationScheme"

export const CustomScorecardSettingsPage = () => {
    const [showSaveConfirmationDialog, setShowSaveConfirmationDialog] = useState(false);
    const confirmShowSaveMessage = "Saving the fields settings will affect all users. Continue?";
    const { control, handleSubmit, formState: { isSubmitting }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(CustomFieldNameValidationScheme),
    });

    const getCustomField = async () => {
        try {
            const response = await CustomScorecardSettings.getCustomFieldName(SettingType.FieldNames);
            const formData = {
                customColumn1: response.data.customColumn1DisplayName,
                customColumn2: response.data.customColumn2DisplayName,
                customColumn3: response.data.customColumn3DisplayName,
                customColumn4: response.data.customColumn4DisplayName,
                customColumn5: response.data.customColumn5DisplayName,
            };
            reset(formData);
        } catch (error) {
            console.log(error);
        }
    }

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            const customColumnNames = {
                sectionId: SettingType.FieldNames,
                customColumn1DisplayName: data.customColumn1,
                customColumn2DisplayName: data.customColumn2,
                customColumn3DisplayName: data.customColumn3,
                customColumn4DisplayName: data.customColumn4,
                customColumn5DisplayName: data.customColumn5,
            } as CustomScorecard.PreferentialProcurementSettings
            const response = await CustomScorecardSettings.saveCustomFieldName(customColumnNames)
            toast.success("Custom Column Names Saved")
        }
        catch (error: any) {
            console.log(error);
        }
        closeSaveConfimation()
    }

    const handleOnClickSave = () => {
        setShowSaveConfirmationDialog(true);
    }
    const closeSaveConfimation = () => {
        setShowSaveConfirmationDialog(false);
    };

    useEffect(() => {
        getCustomField();
    }, [])

    return (
        <>
            <MDTypography display="block" variant='h4' fontWeight='bold' style={{ paddingBottom: "10px" }}>
                Custom Scorecard Settings
            </MDTypography>
            <MDTypography display="block" variant='h5' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                Preferential Procurement
            </MDTypography>
            <MDTypography display="block" graphy color='primary' variant='h6' fontWeight='bold'>
                Field Settings
            </MDTypography>
            <form id='customSettingsForm'>
                <Grid container paddingTop={3} style={{ display: "flex", alignItems: "center" }}>
                    <Grid item xs={5}>
                        <AppTextInput control={control} name="customColumn1" label="Custom Name For Column 1" value={''} />
                    </Grid>
                </Grid>
                <Grid container paddingTop={3} style={{ display: "flex", alignItems: "center" }}>
                    <Grid item xs={5}>
                        <AppTextInput control={control} name="customColumn2" label="Custom Name For Column 2" value={''} />
                    </Grid>
                </Grid>
                <Grid container paddingTop={3} style={{ display: "flex", alignItems: "center" }}>
                    <Grid item xs={5}>
                        <AppTextInput control={control} name="customColumn3" label="Custom Name For Column 3" value={''} />
                    </Grid>
                </Grid>
                <Grid container paddingTop={3} style={{ display: "flex", alignItems: "center" }}>
                    <Grid item xs={5}>
                        <AppTextInput control={control} name="customColumn4" label="Custom Name For Column 4" value={''} />
                    </Grid>
                </Grid>
                <Grid container paddingTop={3} style={{ display: "flex", alignItems: "center" }}>
                    <Grid item xs={5}>
                        <AppTextInput control={control} name="customColumn5" label="Custom Name For Column 5" value={''} />
                    </Grid>
                </Grid>
                <Box mt={2}>
                    <LoadingButton loading={isSubmitting} variant='contained' form='customSettingsForm' color='primary' onClick={handleOnClickSave} >
                        Save Field Settings
                    </LoadingButton>
                </Box>
            </form>
            <ConfirmationDialog
                showDialog={showSaveConfirmationDialog}
                handleAccept={handleSubmit(handleDataSubmit)}
                handleCancel={closeSaveConfimation}
                heading={"Save Field Settings"}
                message={confirmShowSaveMessage}
            />
        </>
    )
}

